import { dateToSeconds } from '@/lib/util/dateTime';

function checkEmptyFields(state: any, isEditStartTime?: boolean) {
  return (
    !state.firstTime.data?.hh ||
    !state.firstTime.data?.mm ||
    !state.firstTime.data?.a ||
    (!isEditStartTime &&
      (!state.secondTime.data?.hh ||
        !state.secondTime.data?.mm ||
        !state.secondTime.data?.a))
  );
}

export function isShiftOverlapping(
  state: any,
  isEditStartTime?: boolean,
  previousTimesheetEndTime?: number
) {
  if (!state.firstTime.data || (!isEditStartTime && !state.secondTime.data)) {
    return false;
  } else if (checkEmptyFields(state, isEditStartTime)) {
    state.emptyField = true;
    return false;
  }

  const MILLISECONDS_IN_SECOND = 1000;
  state.emptyField = false;

  const firstTime = dateToSeconds(
    state.firstDate.getFullYear(),
    state.firstDate.getMonth() + 1,
    state.firstDate.getDate(),
    state.firstTime.data.HH,
    state.firstTime.data.mm
  );

  const secondTime = !isEditStartTime
    ? dateToSeconds(
        state.secondDate.getFullYear(),
        state.secondDate.getMonth() + 1,
        state.secondDate.getDate(),
        state.secondTime.data.HH,
        state.secondTime.data.mm
      )
    : null;

  const isShiftOverlappingPreviousTimesheet =
    previousTimesheetEndTime && firstTime < previousTimesheetEndTime
      ? true
      : false;

  return isEditStartTime
    ? firstTime >= Date.now() / MILLISECONDS_IN_SECOND ||
        isShiftOverlappingPreviousTimesheet
    : secondTime! <= firstTime ||
        secondTime! >= Date.now() / MILLISECONDS_IN_SECOND ||
        isShiftOverlappingPreviousTimesheet;
}
